import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterFeatureArrangementTypeLogic} from "./FilterFeatureArrangementType.logic";
import {CheckboxListItem} from "../../../components/common/checkbox/CheckboxListItem";

export interface IFilterFeatureArrangementType {
  arrangementTypeId: number;
}

export const FilterFeatureArrangementType: VoidFunctionComponent<IFilterFeatureArrangementType> = ({arrangementTypeId}) => {
  const {title, isSelected, handleToggleOnClick} = useFilterFeatureArrangementTypeLogic(arrangementTypeId);
  return (
    <CheckboxListItem
      label={`${title}`}
      onClick={handleToggleOnClick}
      isChecked={isSelected}
    />
  );
}
